import {
  ITextBlock,
  useBlocksActions,
} from '@/models/commercial-proposals/blocks.store';
import {
  Box,
  SegmentedControl,
  Stack,
  TextInput,
  Textarea,
} from '@mantine/core';
import { marked } from 'marked';
import { useState } from 'react';
import BlockBase from './BlockBase';

function Settings({ block }: { block: ITextBlock }) {
  const { update } = useBlocksActions();

  if (!block) return null;

  return (
    <Stack>
      <TextInput
        size="xs"
        label="Title"
        value={block.title}
        onChange={(e) => update({ ...block, title: e.target.value })}
      />
    </Stack>
  );
}

export default function TextBlock({
  block,
  index,
}: {
  block: ITextBlock;
  index: number;
}) {
  const { update } = useBlocksActions();
  const [render, setRender] = useState(false);

  return (
    <BlockBase
      block={block}
      index={index}
      settings={<Settings block={block} />}
      rightActions={
        <SegmentedControl
          size="xs"
          value={render ? 'preview' : 'edit'}
          onChange={(value) => setRender(value === 'preview')}
          p={1}
          data={[
            { label: 'Edit', value: 'edit' },
            { label: 'Preview', value: 'preview' },
          ]}
        />
      }
    >
      <Box mt={'xs'}>
        {render ? (
          <div
            className="md"
            style={{
              padding: 'var(--mantine-spacing-xs)',
              border: '1px solid transparent',
              borderRadius: 'var(--mantine-radius-sm)',
            }}
            dangerouslySetInnerHTML={{
              __html: marked(block.text, { breaks: true }),
            }}
          />
        ) : (
          <Textarea
            size="xs"
            autosize
            minRows={6}
            value={block.text}
            onChange={(e) => {
              update({
                ...block,
                text: e.target.value,
              });
            }}
          />
        )}
      </Box>
    </BlockBase>
  );
}
